/**
 * Die Sperre um die Token-Erneuerung — eine je Browser, nicht eine je Reiter.
 *
 * Jeder Reiter hält seine eigene Kopie der Token. Erneuert einer, dreht der
 * Dienst das Erneuerungstoken weiter und widerruft das alte. Legt der zweite
 * Reiter danach seine Kopie vor, ist das für den Dienst eine Wiederverwendung —
 * und er beendet zu Recht *alle* Sitzungen, auch die des Reiters, der nichts
 * falsch gemacht hat. Zwei offene Reiter genügten, um sich gegenseitig
 * abzumelden.
 *
 * `navigator.locks` ist eine Sperre je Ursprung: Alle Reiter derselben Seite
 * teilen sie, und nur einer hält sie zur Zeit. Wer sie bekommt, sieht zuerst
 * in den Speicher — steht dort schon ein neueres Token, hat der Nachbar die
 * Arbeit bereits getan.
 *
 * Kennt ein Browser die Sperre nicht, läuft die Arbeit ungesperrt: Ein Reiter
 * ohne Sperre ist immer noch besser als keine Erneuerung.
 */

/** Was im Speicher liegt, ist der neueste Stand — der Reiter nebenan schreibt hierhin. */
export const tokenFromStorage = (schluessel: 'accessToken' | 'refreshToken'): string | null => {
  try {
    return localStorage.getItem(schluessel);
  } catch {
    return null;
  }
};

export const withRefreshLock = async <T>(arbeit: () => Promise<T>): Promise<T> => {
  const sperren = (globalThis as { navigator?: { locks?: LockManager } }).navigator?.locks;
  if (!sperren?.request) return arbeit();
  return sperren.request('revilion-token-erneuerung', arbeit) as Promise<T>;
};
